// Stage 3 copy follows the existing bilingual Analytics contract.
const metaAdsTranslations = {
  "tab_meta-ads": { en: "Meta Ads Intelligence", sq: "Inteligjenca e reklamave Meta" },
  tab_metaAds: {
    en: "Meta Ads Intelligence",
    sq: "Inteligjenca e reklamave Meta",
  },
  meta_subtitle: {
    en: "Advertising spend and attributed outcomes · Meta Marketing API",
    sq: "Shpenzimet e reklamave dhe rezultatet e atribuuara · Meta Marketing API",
  },
  meta_preset_7: {
    en: "Last 7 days",
    sq: "7 ditët e fundit",
  },
  meta_preset_28: {
    en: "Last 28 days",
    sq: "28 ditët e fundit",
  },
  meta_preset_90: {
    en: "Last 90 days",
    sq: "90 ditët e fundit",
  },
  meta_preset_thisMonth: {
    en: "Current month",
    sq: "Muaji aktual",
  },
  meta_preset_lastMonth: {
    en: "Previous month",
    sq: "Muaji i kaluar",
  },
  meta_preset_custom: {
    en: "Custom range",
    sq: "Periudhë tjetër",
  },
  meta_dateNote: {
    en: "Presets end yesterday in the ad account timezone; current month includes today. Maximum 180 days.",
    sq: "Periudhat përfundojnë dje sipas zonës kohore të llogarisë; muaji aktual përfshin sot. Maksimumi 180 ditë.",
  },
  meta_spend: {
    en: "Meta ad spend",
    sq: "Shpenzimet e reklamave Meta",
  },
  meta_impressions: {
    en: "Impressions",
    sq: "Shfaqje",
  },
  meta_linkClicks: {
    en: "Link clicks",
    sq: "Klikime në lidhje",
  },
  meta_linkCtr: {
    en: "Link CTR",
    sq: "CTR e lidhjeve",
  },
  meta_purchases: {
    en: "Meta-attributed website purchases",
    sq: "Blerje në faqe të atribuuara nga Meta",
  },
  meta_purchaseRoas: {
    en: "Meta website purchase ROAS",
    sq: "ROAS i blerjeve në faqe sipas Meta",
  },
  meta_purchaseValue: {
    en: "Meta-attributed website purchase value",
    sq: "Vlera e blerjeve në faqe të atribuuara nga Meta",
  },
  meta_reach: {
    en: "Reach",
    sq: "Shtrirja",
  },
  meta_frequency: {
    en: "Frequency",
    sq: "Frekuenca",
  },
  meta_linkCpc: {
    en: "Link CPC",
    sq: "CPC e lidhjeve",
  },
  meta_cpm: {
    en: "CPM",
    sq: "CPM",
  },
  meta_landingPageViews: {
    en: "Landing page views",
    sq: "Shikime të faqes së destinacionit",
  },
  meta_costPerPurchase: {
    en: "Meta-attributed cost per purchase",
    sq: "Kosto për blerje të atribuuar nga Meta",
  },
  meta_help_spend: {
    en: "Spend reported by Meta in the ad account currency.",
    sq: "Shpenzimi i raportuar nga Meta në monedhën e llogarisë.",
  },
  meta_help_impressions: {
    en: "Meta ad impressions. Overall totals come from account reporting, not summed reach or frequency.",
    sq: "Shfaqje të reklamave Meta. Totalet merren nga raporti i llogarisë; shtrirja dhe frekuenca nuk mblidhen.",
  },
  meta_help_linkClicks: {
    en: "inline_link_clicks; this is not all clicks, landing page views or GA4 sessions.",
    sq: "inline_link_clicks; nuk janë të gjitha klikimet, shikimet e destinacionit ose sesionet GA4.",
  },
  meta_help_linkCtr: {
    en: "Link clicks divided by impressions; the same link-click definition is used for CPC.",
    sq: "Klikimet në lidhje pjesëtuar me shfaqjet; e njëjta bazë klikimesh përdoret për CPC.",
  },
  meta_help_purchases: {
    en: "Only offsite_conversion.fb_pixel_purchase is selected. Aliases are never added together. Missing actions remain unavailable.",
    sq: "Përdoret vetëm offsite_conversion.fb_pixel_purchase. Kategoritë e përsëritura nuk mblidhen. Veprimet që mungojnë mbeten të padisponueshme.",
  },
  meta_help_purchaseRoas: {
    en: "Meta website_purchase_roas for website purchases, using Meta-controlled attribution and reporting time. Not realized business profit or internal sales ROAS.",
    sq: "website_purchase_roas sipas Meta për blerjet në faqe; Meta përcakton atribuimin dhe kohën e raportimit. Nuk është fitim real ose ROAS i shitjeve të brendshme.",
  },
  meta_trend: {
    en: "Spend and performance trend",
    sq: "Trendi i shpenzimeve dhe performancës",
  },
  meta_trendNote: {
    en: "Daily Meta values. Missing dates and values are not filled or interpolated. Reach and ROAS must not be summed.",
    sq: "Vlera ditore nga Meta. Datat dhe vlerat që mungojnë nuk plotësohen. Shtrirja dhe ROAS nuk duhet të mblidhen.",
  },
  meta_metric: {
    en: "Trend metric",
    sq: "Metrika e trendit",
  },
  meta_hierarchy: {
    en: "Campaign hierarchy",
    sq: "Hierarkia e fushatave",
  },
  meta_level_campaign: {
    en: "Campaign performance",
    sq: "Performanca e fushatave",
  },
  meta_level_adset: {
    en: "Ad set performance",
    sq: "Performanca e grupeve të reklamave",
  },
  meta_level_ad: {
    en: "Ad performance",
    sq: "Performanca e reklamave",
  },
  meta_hierarchyNote: {
    en: "Rows with reported activity in this period. Status is current Meta effective status. Missing purchase actions do not prove zero sales; messaging and awareness objectives need their own results.",
    sq: "Rreshta me aktivitet të raportuar në këtë periudhë. Statusi është gjendja aktuale nga Meta. Mungesa e blerjeve nuk dëshmon zero shitje; objektivat e mesazheve dhe ndërgjegjësimit kërkojnë rezultatet e tyre.",
  },
  meta_name: {
    en: "Name",
    sq: "Emri",
  },
  meta_objective: {
    en: "Objective",
    sq: "Objektivi",
  },
  meta_status: {
    en: "Delivery status",
    sq: "Statusi i shpërndarjes",
  },
  meta_search: {
    en: "Search campaign, ad set or ad name",
    sq: "Kërko emrin e fushatës, grupit ose reklamës",
  },
  meta_allStatuses: {
    en: "All statuses",
    sq: "Të gjitha statuset",
  },
  meta_allObjectives: {
    en: "All objectives",
    sq: "Të gjithë objektivat",
  },
  meta_status_ACTIVE: {
    en: "Active",
    sq: "Aktive",
  },
  meta_status_PAUSED: {
    en: "Paused",
    sq: "Në pauzë",
  },
  meta_status_ARCHIVED: {
    en: "Archived",
    sq: "Arkivuar",
  },
  meta_status_DELETED: {
    en: "Deleted",
    sq: "Fshirë",
  },
  meta_status_CAMPAIGN_PAUSED: {
    en: "Campaign paused",
    sq: "Fushata në pauzë",
  },
  meta_status_ADSET_PAUSED: {
    en: "Ad set paused",
    sq: "Grupi në pauzë",
  },
  meta_status_PENDING_REVIEW: {
    en: "Pending review",
    sq: "Në pritje të shqyrtimit",
  },
  meta_status_DISAPPROVED: {
    en: "Disapproved",
    sq: "Refuzuar",
  },
  meta_status_PREAPPROVED: {
    en: "Preapproved",
    sq: "Miratuar paraprakisht",
  },
  meta_status_PENDING_BILLING_INFO: {
    en: "Pending billing information",
    sq: "Në pritje të të dhënave të faturimit",
  },
  meta_status_WITH_ISSUES: {
    en: "With issues",
    sq: "Me probleme",
  },
  meta_status_IN_PROCESS: {
    en: "In process",
    sq: "Në proces",
  },
  meta_objective_OUTCOME_SALES: {
    en: "Sales",
    sq: "Shitje",
  },
  meta_objective_OUTCOME_TRAFFIC: {
    en: "Traffic",
    sq: "Trafik",
  },
  meta_objective_OUTCOME_ENGAGEMENT: {
    en: "Engagement",
    sq: "Angazhim",
  },
  meta_objective_OUTCOME_LEADS: {
    en: "Leads",
    sq: "Klientë potencialë",
  },
  meta_objective_OUTCOME_AWARENESS: {
    en: "Awareness",
    sq: "Ndërgjegjësim",
  },
  meta_objective_OUTCOME_APP_PROMOTION: {
    en: "App promotion",
    sq: "Promovim aplikacioni",
  },
  meta_objective_CONVERSIONS: {
    en: "Conversions (legacy)",
    sq: "Konvertime (i vjetër)",
  },
  meta_objective_LINK_CLICKS: {
    en: "Link clicks (legacy)",
    sq: "Klikime në lidhje (i vjetër)",
  },
  meta_objective_MESSAGES: {
    en: "Messages (legacy)",
    sq: "Mesazhe (i vjetër)",
  },
  meta_results: {
    en: "Available Meta results / cost per result",
    sq: "Rezultate Meta / kosto për rezultat",
  },
  meta_result: {
    en: "result",
    sq: "rezultat",
  },
  meta_action_offsite_conversion_fb_pixel_purchase: {
    en: "Website purchases",
    sq: "Blerje në faqe",
  },
  meta_action_landing_page_view: {
    en: "Landing page views",
    sq: "Shikime të destinacionit",
  },
  meta_action_link_click: {
    en: "Link clicks",
    sq: "Klikime në lidhje",
  },
  meta_action_post_engagement: {
    en: "Post engagements",
    sq: "Angazhime me postimin",
  },
  meta_action_lead: {
    en: "Leads",
    sq: "Klientë potencialë",
  },
  meta_action_onsite_conversion_messaging_conversation_started_7d: {
    en: "Messaging conversations",
    sq: "Biseda me mesazhe",
  },
  meta_attribution: {
    en: "Attribution setting",
    sq: "Cilësimi i atribuimit",
  },
  meta_inheritedAttribution: {
    en: "Attribution details unavailable; inspect Ads Manager",
    sq: "Detajet e atribuimit nuk janë të disponueshme; kontrolloni Ads Manager",
  },
  meta_page: {
    en: "Page {page}",
    sq: "Faqja {page}",
  },
  meta_platforms: {
    en: "Facebook and Instagram placements",
    sq: "Vendosjet në Facebook dhe Instagram",
  },
  meta_platformNote: {
    en: "Meta publisher platform and placement delivery, not GA4 acquisition. Purchase breakdowns are unavailable here. Reach and frequency are intentionally omitted to avoid double counting.",
    sq: "Shpërndarja sipas platformës dhe vendosjes Meta, jo burime GA4. Blerjet sipas vendosjes nuk ofrohen këtu. Shtrirja dhe frekuenca nuk paraqiten për të shmangur numërimin e dyfishtë.",
  },
  meta_platform: {
    en: "Platform / placement",
    sq: "Platforma / vendosja",
  },
  meta_platformSummary: {
    en: "Platform summary",
    sq: "Përmbledhje platformash",
  },
  meta_placementDetail: {
    en: "Inspect placements",
    sq: "Shiko vendosjet",
  },
  meta_comparison: {
    en: "Ads, website and recorded sales",
    sq: "Reklamat, faqja dhe shitjet e regjistruara",
  },
  meta_comparisonNote: {
    en: "Independent sources for the same visible calendar dates. Timezones and attribution can differ. Meta does not identify which internal sales it caused. Currencies are shown separately; no FX conversion, blended ROAS or profit subtraction is applied.",
    sq: "Burime të pavarura për të njëjtat data kalendarike. Zonat kohore dhe atribuimi mund të ndryshojnë. Meta nuk identifikon cilat shitje të brendshme ka shkaktuar. Monedhat shfaqen veçmas; nuk bëhet konvertim valutor, ROAS i përzier ose zbritje nga fitimi.",
  },
  meta_timezones: {
    en: "Reporting timezones",
    sq: "Zonat kohore të raportimit",
  },
  meta_ledger: {
    en: "Sales ledger",
    sq: "Regjistri i shitjeve",
  },
  meta_paidSocialSessions: {
    en: "GA4 Paid Social sessions",
    sq: "Sesione Paid Social në GA4",
  },
  meta_gaPurchases: {
    en: "GA4 website purchase events",
    sq: "Ngjarje blerjeje në GA4",
  },
  meta_gaValue: {
    en: "GA4-tracked order value",
    sq: "Vlera e porosive të gjurmuara nga GA4",
  },
  meta_websiteNetSales: {
    en: "Recorded website net sales",
    sq: "Shitje neto të regjistruara nga faqja",
  },
  meta_websiteSalesCount: {
    en: "Recorded website sales count",
    sq: "Numri i shitjeve të regjistruara nga faqja",
  },
  meta_allNetSales: {
    en: "Recorded net sales · all channels",
    sq: "Shitje neto të regjistruara · të gjitha kanalet",
  },
  meta_delivery: {
    en: "Delivery and purchase context",
    sq: "Konteksti i shpërndarjes dhe blerjeve",
  },
  meta_insights: {
    en: "Observations",
    sq: "Vëzhgime",
  },
  meta_insightsNote: {
    en: "Deterministic comparisons for the selected period. No causal claims, budget recommendations or automated advertising changes.",
    sq: "Krahasime të llogaritura për periudhën e zgjedhur. Pa pretendime shkakësore, rekomandime buxheti ose ndryshime automatike.",
  },
  meta_insight_spend_change: {
    en: "Meta spend changed by {value} versus the equal previous period.",
    sq: "Shpenzimet Meta ndryshuan me {value} krahasuar me periudhën e mëparshme me gjatësi të njëjtë.",
  },
  meta_insight_instagram_spend: {
    en: "Instagram received {value} more advertising spend than Facebook.",
    sq: "Instagram mori {value} më shumë shpenzim reklamash se Facebook.",
  },
  meta_insight_spend_up_roas_down: {
    en: "Spend increased while Meta website purchase ROAS changed by {value}. Review objectives and attribution before drawing conclusions.",
    sq: "Shpenzimet u rritën ndërsa ROAS i blerjeve në faqe ndryshoi me {value}. Kontrolloni objektivat dhe atribuimin para përfundimeve.",
  },
  meta_noInsights: {
    en: "Insufficient comparable data for a reliable observation.",
    sq: "Nuk ka të dhëna të mjaftueshme të krahasueshme për vëzhgim të besueshëm.",
  },
  meta_fetched: {
    en: "Fetched {at} · cached up to 15 minutes",
    sq: "Marrë më {at} · memorje deri në 15 minuta",
  },
  meta_attributionNote: {
    en: "Source: Meta Marketing API. Meta controls attribution and reporting time to match Ads Manager settings; this integration does not enforce impression-date reporting. Click/view windows may differ across ad sets. Results can change as attribution matures. Attributed purchases are not paid or delivered internal orders.",
    sq: "Burimi: Meta Marketing API. Meta përcakton atribuimin dhe kohën e raportimit sipas cilësimeve të Ads Manager; ky integrim nuk imponon raportim sipas datës së shfaqjes. Afatet pas klikimit/shikimit mund të ndryshojnë mes grupeve. Rezultatet mund të ndryshojnë me përpunimin e atribuimit. Blerjet e atribuuara nuk janë porosi të brendshme të paguara ose të dorëzuara.",
  },
  meta_todayNote: {
    en: "Today is incomplete. Previous-period comparisons are disabled.",
    sq: "Dita e sotme është e paplotë. Krahasimet me periudhën e kaluar janë çaktivizuar.",
  },
  meta_empty: {
    en: "No Meta insights reported for this period",
    sq: "Nuk ka të dhëna Meta për këtë periudhë",
  },
  meta_noRows: {
    en: "No reported rows. Missing metrics are unavailable, not proven zero outcomes.",
    sq: "Nuk ka rreshta të raportuar. Metrikat që mungojnë janë të padisponueshme, jo rezultate të dëshmuara zero.",
  },
  meta_connectHelp: {
    en: "An administrator must configure the server-only ad account binding and an authorized ads_read token. No sample figures are displayed.",
    sq: "Administratori duhet të konfigurojë llogarinë në server dhe një token të autorizuar ads_read. Nuk shfaqen shifra provë.",
  },
  meta_state_not_configured: {
    en: "Meta Ads reporting is not configured",
    sq: "Raportimi Meta Ads nuk është konfiguruar",
  },
  meta_state_expired_token: {
    en: "Meta token is invalid, expired or revoked",
    sq: "Token Meta është i pavlefshëm, i skaduar ose i revokuar",
  },
  meta_state_permission_denied: {
    en: "Meta reporting permission denied",
    sq: "Qasja në raportimin Meta u refuzua",
  },
  meta_state_rate_limited: {
    en: "Meta rate limit reached. Retry later.",
    sq: "Kufiri i kërkesave Meta është arritur. Provoni më vonë.",
  },
  meta_state_unavailable: {
    en: "Meta reporting is temporarily unavailable",
    sq: "Raportimi Meta është përkohësisht i padisponueshëm",
  },
  meta_state_unsupported_report: {
    en: "Meta rejected this reporting combination. Clear filters or shorten the range.",
    sq: "Meta refuzoi këtë kombinim raportimi. Pastroni filtrat ose shkurtoni periudhën.",
  },
  meta_state_partial: {
    en: "Some report rows or metadata are limited or unavailable. Totals are not derived from incomplete breakdowns.",
    sq: "Disa rreshta ose të dhëna shpjeguese janë të kufizuara ose të padisponueshme. Totalet nuk nxirren nga ndarje të paplota.",
  },
};

export default metaAdsTranslations;
